type Props = {
  onClick?: () => void;
};

const GameCardTemplate: FC<Props> = ({ onClick, children }) => (
  <div
    className="grid grid-cols-minmax gap-2"
    data-testid="thumb-wrapper"
    onClick={onClick}
  >
    {children}
  </div>
);

export default GameCardTemplate;
